import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AuthToken } from './model/authToken';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { Contato, ContatoResponse, Entidade, EntidadeResponse } from './model/entidade';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable({
  providedIn: 'root'
})
export class EntidadeService {
  constructor(private httpClient: HttpClient,
    private loginService: LoginService,
    private router: Router) { }

  servicePath: string = '/entidade'

  url:string = environment.apiUri + this.servicePath;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'x-access-token': this.loginService.getToken() })
  }


  get() : Observable<EntidadeResponse> {
    return this.httpClient.get<EntidadeResponse>(this.url + '?status=A&tipo=CF', this.httpOptions)
    .pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  getById(id:number) : Observable<EntidadeResponse> {
    return this.httpClient.get<EntidadeResponse>(this.url + '/' + id, this.httpOptions)
    .pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  getCnpj(cnpj:string) : Observable<EntidadeResponse> {
    return this.httpClient.get<EntidadeResponse>(environment.apiUri + '/consultaCNPJ/' + cnpj, this.httpOptions)
    .pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  getCep(cep:string) : Observable<EntidadeResponse> {
    // console.log('chegou no serviço')
    return this.httpClient.get<EntidadeResponse>(environment.apiUri + '/consultaCEP/' + cep, this.httpOptions)
    .pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  create(entity:Entidade) : Observable<any> {
    return this.httpClient.post(this.url, entity, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  update(entity:Entidade) : Observable<any> {
    return this.httpClient.put(this.url + '/' + entity.id,entity, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  delete(id:number) : Observable<any> {
    return this.httpClient.delete(this.url + '/' + id, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  updateContato(idEntidade:number,entity:Contato) : Observable<any> {
    return this.httpClient.put(`${this.url}/${idEntidade}/contato/${entity.id}`,entity, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  createContato(idEntidade:number,entity:Contato) : Observable<any> {
    
    return this.httpClient.post(`${this.url}/${idEntidade}/contato`, entity, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  deleteContato(idEntidade:number,idContato:number) : Observable<any> {
    return this.httpClient.delete(`${this.url}/${idEntidade}/contato/${idContato}`, this.httpOptions)
    .pipe(
      catchError(this.handleError)
    )
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
 
    }
    if(error.status == 401){
      Swal.fire({
        title:  "Desculpe!",
        text: "É necessário estar logado para acessar esta página.",
        icon: 'warning'
      });
      this.router.navigate(['/login']); 
    }
    return throwError(error);
  };

}
